module.exports = __webpack_public_path__ + "static/media/pannovate_logo_black.e3cd8519.svg";